import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
}
const _hoisted_2 = { class: "max-w-md w-full space-y-8 bg-white p-10 rounded-md" }
const _hoisted_3 = {
  action: "#",
  class: "mt-8 space-y-6"
}
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "mt-1" }

import { inject, onMounted, ref } from "vue";
import { Switch } from "@headlessui/vue";
import { useStore } from "vuex";
import { AxiosInstance } from "axios";
interface BankVerifyConfig { verifyBankAccount: boolean, operatorId: string, allowManualRegister: boolean }


export default /*#__PURE__*/_defineComponent({
  __name: 'bankVerifyConfig',
  setup(__props) {

const disableBankVerify = ref({
  is_active: false
})
const disableAllowManualInput = ref({
  is_active: false
})

const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const isLoading = ref(false);
const isShow = ref<Boolean>(false)
const getOperator = async () => {
  isLoading.value = true
  try {
    let payload = {
    id: store.state.selectedOperator.operatorId,
  }
  const result = await axios
    .post<any>(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator/read`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(({ data }) => {
      disableBankVerify.value.is_active = data.verifyBankAccount
      disableAllowManualInput.value.is_active = data.allowManualRegister
    }
    )
  } catch (error) {
    alert("Get Operator Error")
    console.log(error)
  }
  
}

const toggleDisableBankVerify = async () => {
  disableBankVerify.value.is_active = !disableBankVerify.value.is_active;
  onSave()
}

const toggleDisableAllowManualInput = async () => {
  disableAllowManualInput.value.is_active = !disableAllowManualInput.value.is_active;
  onSave()
}

const onSave = async () => {
  try {
      isLoading.value = true
      let payload:BankVerifyConfig = {
        verifyBankAccount: disableBankVerify.value.is_active,
        operatorId: store.state.selectedOperator.operatorId,
        allowManualRegister: disableAllowManualInput.value.is_active
      }
      console.log(payload)
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator/bank-verify/config`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      if (!data || data.status !== 'success') {
        alert("update fail !")
        throw new Error('err')
      }
      isLoading.value = false
    } catch (error) {
      alert("Update Config Error")
      getOperator()
      isLoading.value = false
    }
}

onMounted(() => {
  if (store.state.user.permissions.includes('PAYMENT.UPDATE')) isShow.value = true
  getOperator()
})

return (_ctx: any,_cache: any) => {
  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t("messages.navigation.bankVerifyConfig")), 1),
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("messages.bankVerifyConfig.bankVerify")), 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Switch), {
                  modelValue: disableBankVerify.value.is_active,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((disableBankVerify.value.is_active) = $event)),
                  class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", disableBankVerify.value.is_active
                ? 'bg-blue-400'
                : 'bg-red-500'
                ]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleDisableBankVerify()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass([disableBankVerify.value.is_active
                ? 'translate-x-6'
                : 'translate-x-1'
                , "inline-block h-4 w-4 transform rounded-full bg-white"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("messages.bankVerifyConfig.allowManualInput")), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Switch), {
                  modelValue: disableAllowManualInput.value.is_active,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((disableAllowManualInput.value.is_active) = $event)),
                  class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", disableAllowManualInput.value.is_active
                ? 'bg-blue-400'
                : 'bg-red-500'
                ]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleDisableAllowManualInput()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass([disableAllowManualInput.value.is_active
                ? 'translate-x-6'
                : 'translate-x-1'
                , "inline-block h-4 w-4 transform rounded-full bg-white"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})